import React, {useState, useRef, Suspense} from 'react'
import styled from 'styled-components'
import  { Canvas } from '@react-three/fiber'
import  { OrbitControls, useGLTF } from '@react-three/drei'

const StyledApp = styled.div`
 margin: 0;
 padding: 0;
 background-color: #ddd;
 background-image: url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%234b484f' fill-opacity='0.09'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

.wrapper-sneaker-logo{
  transform: translate3d(0,2em,0);
  height: 2.54em;
  width: auto;
  padding: 1.55em;
  text-align: center;
  margin: auto;
  aspect-ratio: 9/7;
  border: 6px solid #222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  filter: blur(0.5);
  line-height: 1.1;
}
.sneaker-logo {
  color: #222;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.12ch;
  width: 100%;
  font-size: 1.32em;
  margin-top: -0.68em;
}
.sneaker-logo p {
  color: #333;
  font-weight: bold;
  margin-top: -1.32em;
  letter-spacing: 0.12ch;
  width: 100%;
  font-size: 0.48em;
}
.wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-around;
    /* background-color: #5dafb8; */
    color:white;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.card {
    margin-top: 0;
    height: auto;
    border-radius: 13px;
    box-shadow: 20px 40px 33px rgba(0,0,0,0.3);
    padding: 2rem 2rem 2.25rem 2rem;
    width: 50%;
    /* background-color:  #6cc2ce; */
    background-color: #333;
    filter: sepia(0.32) contrast(1.2);
}
@media screen and (max-width:750px) {
  .card {
    width: 100%;
    padding: 1em;
  }

  .wrapper-sneaker-logo{
  transform: translate3d(0,0.1em,0);
  height: 2.54em;
  width: auto;
  padding: 0.55em;
  text-align: center;
  margin: auto;
  aspect-ratio: 9/7;
  border: 3px solid #222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  filter: blur(0.5);
  line-height: 1.1;
}
.sneaker-logo {
  color: #222;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.12ch;
  width: 100%;
  font-size: 1em;
  margin-top: -0.68em;
}
.sneaker-logo p {
  color: #333;
  font-weight: bold;
  margin-top: -1.32em;
  letter-spacing: 0.12ch;
  width: 100%;
  font-size: 0.48em;
}

}
.product-canvas {
    cursor: grab ;
    width: 100%;
    height: 38vh;
    box-shadow:  5px 7px 7px 6px rgba(0,0,0,0.13);
    border-radius: 0px;
    margin-bottom:20px;
    background-color: rgba(0,135,245,0.12);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23a9dbf9' fill-opacity='0.4'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

}

.colors {
  display:flex;
  flex-direction:row;
  flex-wrap: wrap;
  max-width: 67%;
  width: 60%;
}

.colors div {
  padding:8px;
}
label {
  padding: 0 1em 0 .32em;
  color: #ccc;
  font-size: 0.9em;
  filter: contrast(1.3);
}
`;
 
function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/shoe.gltf')
  return (
    <group ref={group} {...props} dispose={null} scale={3}>
      <mesh geometry={nodes.shoe.geometry} material={materials.laces} material-color={props.customColors.laces} />
      <mesh geometry={nodes.shoe_1.geometry} material={materials.mesh} material-color={props.customColors.mesh} />
      <mesh geometry={nodes.shoe_2.geometry} material={materials.caps} />
      <mesh geometry={nodes.shoe_3.geometry} material={materials.inner} material-color={props.customColors.insideTrim} />
      <mesh geometry={nodes.shoe_4.geometry} material={materials.sole} material-color={props.customColors.sole} />
      <mesh geometry={nodes.shoe_5.geometry} material={materials.stripes} material-color={props.customColors.stripes} />
      <mesh geometry={nodes.shoe_6.geometry} material={materials.band} material-color={props.customColors.pullBands} />
      <mesh geometry={nodes.shoe_7.geometry} material={materials.patch} material-color={props.customColors.backPatch} />
    </group>
  )
}
const App = () => {
    const ref = useRef();
    // const {nodes, materials } = useGLTF.preload('/shoe.gltf')
    const [meshColor, setMeshColor] = useState('#efefef');
    const [stripesColor, setStripesColor] = useState('#efefef');
    const [soleColor, setSoleColor] = useState('#efefef');
    const [lacesColor, setLacesColor] = useState('#efefef');
    const [insideTrimColor, setInsideTrimColor] = useState('#efefef');
    const [pullBandsColor, setPullBandsColor] = useState('#efefef');
    const [backPatchColor, setBackPatchColor] = useState('#efefef');

    return (
    <StyledApp>
      <div className="wrapper-sneaker-logo">
        <div className="sneaker-logo">
          <h2>SneakyGood</h2>
          <p>Quality footwear in your hands</p>
        </div>
      </div>
   <div className="wrapper">
        <div className="card">
          <p>(pinch to zoom)&nbsp;&amp;&nbsp;(drag to rotate)</p>
            <div className="product-canvas">
              <Canvas>
<Suspense fallback={null}>
  <ambientLight />
  <spotLight intensity={0.09} angle={0.1} penumbra={1} 
              position={[10,15,10]} castShadow />
  <Model customColors={{mesh:`${meshColor}`,stripes:`${stripesColor}`,sole:`${soleColor}`,laces:`${lacesColor}`,insideTrim:`${insideTrimColor}`,pullBands:`${pullBandsColor}`,backPatch:`${backPatchColor}`}} />
  <OrbitControls enablePan={true}
                 enableZoom={true} 
                 enableRotate={true} />
</Suspense>
              </Canvas>
            </div>
            <h2>Choose Your Custom Color</h2>
            <div className='colors'>
                 <div>
                    <input onChange={(e)=>{setMeshColor(e.target.value)}} type="color" id="mesh" name="mesh"
                           value={meshColor} />
                    <label for="mesh">Main</label>
                  </div>

                <div>
                    <input onChange={(e)=>{setStripesColor(e.target.value)}} type="color" id="stripes" name="stripes"
                            value={stripesColor} />
                    <label for="stripes">Stripes</label>
                </div>
                 <div>
                    <input onChange={(e)=>{setSoleColor(e.target.value)}} type="color" id="sole" name="sole"
                            value={soleColor} />
                    <label for="sole">Sole</label>
                </div>
                 <div>
                    <input onChange={(e)=>{setLacesColor(e.target.value)}} type="color" id="laces" name="laces"
                            value={lacesColor} />
                    <label for="laces">Laces</label>
                </div>
                 <div>
                    <input onChange={(e)=>{setInsideTrimColor(e.target.value)}} type="color" id="insideTrim" name="insideTrim"
                            value={insideTrimColor} />
                    <label for="laces">Inner</label>
                </div>
                 <div>
                    <input onChange={(e)=>{setPullBandsColor(e.target.value)}} type="color" id="pullBands" name="pullBands"
                            value={pullBandsColor} />
                    <label for="laces">Pull-Bands</label>
                </div>
                 <div>
                    <input onChange={(e)=>{setBackPatchColor(e.target.value)}} type="color" id="backPatch" name="backPatch"
                            value={backPatchColor} />
                    <label for="laces">Back-Patch</label>
                </div>
            </div>
        </div>
    </div>
     

    </StyledApp>
    )
}
 
export default App
 